import { JSX } from 'react'

import logo from '../../assets/img/heart_logo.svg'

export const ReminderLogo = (): JSX.Element => {
  return <img src={logo} height="25" alt="reminder" id="reminderLogo" />
}
